<template>
  <va-page-layout @toggleSidebar="toggleSidebar" :mobileWidth="mobileWidth">
    <app-navbar  :minimized.sync="minimized" />
    <app-sidebar  :minimized="minimized" />
    <main
      slot="content"
      id="content"
      class="layout gutter--xl fluid"
      :class="{'app-layout__main--full-width-sidebar': !minimized}"
      role="main"
    >
      <router-view class="pt-5" />
    </main>
  </va-page-layout>
</template>

<script>
import VaPageLayout from './VaPageLayout'
import AppNavbar from './app-navbar/AppNavbar'
import AppSidebar from './app-sidebar/AppSidebar'
import { mapGetters } from 'vuex'
import AppTopbar from './app-topbar/AppTopbar'

export default {
  name: 'app-layout',
  components: {
    AppTopbar,
    VaPageLayout,
    AppNavbar,
    AppSidebar,
  },
  data () {
    return {
      minimized: false,
      mobileWidth: 767,
    }
  },
  computed: {
    ...mapGetters(['isLoading']),
  },
  methods: {
    toggleSidebar (minimized) {
      this.minimized = minimized
    },
  },
}
</script>

<style lang="scss">
.app-layout {
  &__main {
    &--full-width-sidebar {
      @include media-breakpoint-down(xs) {
        display: none;
      }
    }
  }
}
.va-sidebar-link-group__submenu{
background-color: #212121 !important;
}
.va-sidebar-link
{
  background-color: #2b2828 !important;
}

.va-navbar__shape {
  border-top: 4.0625rem solid #0a0106 !important;
  position:fixed!important;z-index:1!important
}
.va-sidebar {
  background-color: #282b28 !important;
  overflow-y: hidden !important;
}
.va-sidebar-link:hover {
  background-color: #2b2828 !important;
}
.va-sidebar-link--active {
  background-color: #2b2828 !important;
}
.content-wrap {
  background-color: #F4F3EF !important;
  min-height:800px!important;
  max-height:8000px!important;
}
#app{
   background-color: #F4F3EF !important;

}
.table .thead-dark th {
  color: #fff;
  background-color: #454d55 !important;
  border-color: #454d55;
  padding-top:15px!important;
  padding-bottom:15px!important;
}
.pdngtblcol1 {
  padding-left: 20px !important;
}
.cnt
{
    text-align: center!important;
}
// .app
// {
//  background-color: #2b2828 !important;
// }
</style>
